import React, { ReactNode } from 'react';
import './typography-item.scss';

type TTagName =
	| 'h1'
	| 'h2'
	| 'h3'
	| 'h4'
	| 'h5'
	| 'h6'
	| 'p'
	| 'span'
	| 'div'
	| 'a'
	| 'time';

interface ITypographyItemProps {
	children: ReactNode;
	tagName?: TTagName;
	className?: string;
	error?: boolean;
	[key: string]: any;
}

export const TypographyItem = ({
	children,
	tagName = 'div',
	className = '',
	error,
	...rest
}: ITypographyItemProps): JSX.Element => {
	const TagName = `${tagName}` as keyof JSX.IntrinsicElements;

	return (
		<TagName
			className={`${className} ${error ? 'typography-item-error' : ''}`}
			{...rest}
		>
			{children}
		</TagName>
	);
};